<template>
    <tbody v-if="isNumbered" class="numbered-section">
        <tr v-for="(line, index) in numberedLines" :key="'line-' + index">
            <td v-html="line.content"></td>
            <td><p v-if="line.number % 5 == 0">{{ line.number }}</p></td>
        </tr>
    </tbody>
    <tbody v-else>
        <tr>
            <td colspan="2" v-html="content"></td>
        </tr>
    </tbody>
</template>

<script>
export default {
    props: {
        content: { type: String, required: true },
        isNumbered: { type: Boolean, required: true }
    },

    computed: {
        numberedLines(){
            if(this.isNumbered){
                // Get the line number from the div data attribute
                let lineNumber = this.content.match(/<div class=\"numberedlines\" data-line-number=\"(\d+?)\"[^>]*>.+?<\/div>/)[1];
                // Get the div inner content
                let innerContent = this.content.match(/<div class=\"numberedlines\"[^>]*>(.+?)<\/div>/)[1];
                // When paragraphs are defined, use the whole paragraph as separator (from the opening to the closing p tags, and everything in between)
                // This is required to preserve the paragraph attributes
                let lines = innerContent.split(/[\r\n]+|<br>|<br \/>|(<p[^>]*>.+?<\/p>)/);
                // Remove the empty values from the lines array
                lines = lines.filter((value) => value !== '' && value !== undefined);
                // Return an array of objects containing the line content and the line number
                return lines.map((lineContent) => {

                    // remove all tags from line content
                    let strippedLineContent = lineContent.replace(/(<([^>]+)>)/gi, "");
                    // remove trailing spaces from stripped line content
                    strippedLineContent = strippedLineContent.replace(/^\s+$/, "");

                    return {
                        'content': lineContent,
                        'number': (strippedLineContent !== '' && strippedLineContent !== undefined) ? lineNumber++ : undefined
                    }
                });
            } else {
                // When the text section is not numbered, return an empty array
                return [];
            }
        }
    },
}
</script>

<style lang="scss">
    tbody.numbered-section {
        tr {
            td {
                vertical-align: top;

                p {
                    margin-bottom: 0.3rem !important;
                }

                &:first-child {
                    width: 100%;
                }

                &:nth-child(2){
                    padding-right: 10px;
                    padding-top: 2px;
                    color: #aaa;
                    font-size: 0.8rem;
                    -webkit-touch-callout: none;
                    -webkit-user-select: none;
                    -khtml-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
        }
    }
</style>
